import { useEffect, useRef } from "react";
import type { AnimationItem } from "lottie-web";

export function useLottie(path: string) {
  const elementRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<AnimationItem | null>(null);

  useEffect(() => {
    let mounted = true;

    // Only run on client
    if (typeof window === "undefined") return;

    // Dynamically import lottie-web
    const loadAnimation = async () => {
      try {
        const lottie = (await import("lottie-web")).default;

        // Check if component is still mounted and wasn't already initialized
        if (mounted && elementRef.current && !animationRef.current) {
          animationRef.current = lottie.loadAnimation({
            container: elementRef.current,
            renderer: "svg",
            loop: true,
            autoplay: true,
            path,
          });
        }
      } catch (error) {
        console.error("Error loading Lottie animation:", error);
      }
    };

    loadAnimation();

    // Cleanup function
    return () => {
      mounted = false;
      if (animationRef.current) {
        animationRef.current.destroy();
        animationRef.current = null;
      }
    };
  }, [path]); // Only re-run if path changes

  return elementRef;
}
